import React from 'react'
import PropTypes from 'prop-types'
import {
  List,
  ListItem,
  ListItemText,
  Divider,
} from '@material-ui/core'
import { Typography } from '@eqworks/react-labs'
import { Link } from 'react-router-dom'
import { useWindowDimensions } from '../../../../../hooks/index'
import { hasFinAccess } from '../../../../../helpers/utils/auth'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(() => ({
  itemText: {
    color: 'rgba(0,0,0,0.87)',
  },
}))

const getContent = (type) => ({
  navItem: NavItemsContent,
  settings: SettingsContent,
}[type])

const NavItemsContent = ({ finalRoutes, menuItems, basePath, handleClose }) => (
  <List>
    {finalRoutes.filter(({ root }) => root === menuItems).map(({ route, content }) => (
      <ListItem key={route} button component={Link} to={`${basePath}/${route}`} onClick={handleClose}>
        <ListItemText primary={content} />
      </ListItem>
    ))}
  </List>
)

const SettingsContent = ({ classes, email, logOut, handleLogoutAll, basePath }) => (
  <List>
    <ListItem>
      <ListItemText
        primary={<Typography secondary={600}>Logged in as</Typography>}
        secondary={<Typography secondary={900} variant='body2'>{email}</Typography>}
      />
    </ListItem>
    <Divider />
    {hasFinAccess() && <ListItem button>
      <a href={`${basePath}/finance`}>
        <ListItemText className={classes.itemText} primary='Finance' />
      </a>
    </ListItem>}
    <ListItem button onClick={logOut}>
      <ListItemText primary='Logout' />
    </ListItem>
    <ListItem button onClick={handleLogoutAll}>
      <ListItemText primary='Logout for all' />
    </ListItem>
  </List>
)

const NavContent = ({ email, type, menuItems, basePath, finalRoutes, logOut, logOutAll, handleClose }) => {
  const classes = useStyles()
  const Content = getContent(type)
  const { width } = useWindowDimensions()
  const isMobile = 960

  return <Content
    classes={classes}
    email={email}
    menuItems={menuItems}
    basePath={basePath}
    finalRoutes={finalRoutes}
    width={width}
    isMobile={isMobile}
    logOut={logOut}
    handleLogoutAll={logOutAll}
    handleClose={handleClose}
  />
}

const navProps = {
  email: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  menuItems: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  finalRoutes: PropTypes.array.isRequired,
  logOut: PropTypes.func.isRequired,
  logOutAll: PropTypes.func.isRequired,
  handleClose: PropTypes.func.isRequired,
}
const settingsProps = {
  classes: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  readme: PropTypes.string.isRequired,
  logOut: PropTypes.func.isRequired,
  handleLogoutAll: PropTypes.func.isRequired,
  handleReadme: PropTypes.func.isRequired,
  basePath: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
  isMobile: PropTypes.number.isRequired,
}
const navItemsProps = {
  finalRoutes: PropTypes.array.isRequired,
  menuItems: PropTypes.string.isRequired,
  basePath: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  width: PropTypes.number.isRequired,
  isMobile: PropTypes.number.isRequired,
}

NavContent.propTypes = navProps
SettingsContent.propTypes = settingsProps
NavItemsContent.propTypes = navItemsProps


export default NavContent
